const socialNetworks = [
  {
    icon: '/icons/social/vk.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_VK
  },
  {
    icon: '/icons/social/telegram.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_TELEGRAM
  },
  {
    icon: '/icons/social/instagram.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_INSTAGRAM
  },
  {
    icon: '/icons/social/facebook.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_FACEBOOK
  },
  {
    icon: '/icons/social/tik-tok.svg',
    url: import.meta.env.VITE_BRAND_SOCIAL_TIKTOK
  }
]

export const SOCIAL = socialNetworks.filter(network => network.url)